import type { Locale } from "./locale";

function baseUrl(): string {
  const b =
    (typeof import.meta !== "undefined" &&
      (import.meta as unknown as { env?: { BASE_URL?: string } }).env?.BASE_URL) ||
    "/";
  return b.endsWith("/") ? b : `${b}/`;
}

/** Base-path-safe URL for a root-relative public asset ("/brand/x.png"). */
export function assetUrl(path: string): string {
  if (/^([a-z]+:|\/\/)/i.test(path)) return path;
  return `${baseUrl()}${path.replace(/^\//, "")}`;
}

/**
 * Locale-specific public asset: Spanish variants live under /es/ with the
 * same filename (e.g. /es/locations/goshen-in.svg, /es/lead-magnets/*.html).
 */
export function localizedAssetUrl(path: string, locale: Locale): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return assetUrl(locale === "es" ? `/es${p}` : p);
}
